/* eslint-disable max-len */
import request from 'superagent';
// import _ from 'lodash';

const { REACT_APP_API_URL, REACT_APP_API_URL_DEV, NODE_ENV } = process.env;
const API_URL = NODE_ENV === 'production' ? REACT_APP_API_URL : REACT_APP_API_URL_DEV;

export function post ({
  endpoint,
  payload,
}) {
  return new Promise((resolve, reject) => {
    request.post(`${API_URL}${endpoint}`)
      .send(payload)
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .then((response) => resolve(response.body))
      .catch((error) => {
        if (error.response) {
          /* eslint-disable prefer-promise-reject-errors */
          reject({ code: error.response.status, message: error.response.body });
        } else if (error.request) {
          // The request was made but no response was received
          // (e.g., network issues, server down)
          reject({ code: '500', message: 'No response received' });
        } else {
          reject({ code: '500', message: 'Something went wrong' });
        }
      });
  });
}

// export function patch ({
//   endpoint,
//   payload,
// }) {
//   return new Promise((resolve, reject) => {
//     request.patch(`${API_URL}${endpoint}`)
//       .send(payload)
//       .set('Accept', 'application/json')
//       .set('Content-Type', 'application/json')
//       .then((response) => resolve(mapCode(response.body)))
//       .catch((error) => reject(error));
//   });
// }

// export function remove ({
//   endpoint,
//   payload,
// }) {
//   return new Promise((resolve, reject) => {
//     request.delete(`${API_URL}${endpoint}`)
//       .then((response) => resolve(mapCode(response.body)))
//       .catch((error) => reject(error));
//   });
// }
